import React from "react";
import { Box, TextField as MuiTextField } from "@mui/material";

class Filter extends React.Component {
    constructor(props) {
        super(props);
        // Initialize state for each filter key
        const filterKeys = props.filterKeys || [];
        const state = { timeout: "" };
        filterKeys.forEach((key) => {
            state[key] = props[key] || "";
        });
        this.state = state;
    }

    componentDidUpdate(prevProps) {
        // Update state if any filter prop changes
        const filterKeys = this.props.filterKeys || [];
        let changed = false;
        const newState = {};
        filterKeys.forEach((key) => {
            if (prevProps[key] !== this.props[key]) {
                newState[key] = this.props[key] || "";
                changed = true;
            }
        });
        if (changed) {
            this.setState(newState);
        }
    }

    delayedOnChange = (ev) => {
        ev.stopPropagation();
        clearTimeout(this.state.timeout);
        const { name, value } = ev.target;
        this.setState({
            [name]: value,
            timeout: setTimeout(() => {
                const payload = {};
                (this.props.filterKeys || []).forEach((key) => {
                    payload[key] = this.state[key];
                });
                this.props.onChange(payload);
            }, 1000),
        });
    };

    render() {
        const { filterKeys = [], labels = {} } = this.props;
        return (
            <Box component="div" sx={{ minHeight: "56px" }}>
                {filterKeys.map((key) => (
                    <MuiTextField
                        key={key}
                        name={key}
                        label={labels[key] || key}
                        variant="filled"
                        value={this.state[key]}
                        onChange={this.delayedOnChange}
                        style={{ marginTop: "10px", marginRight: "10px" }}
                    />
                ))}
            </Box>
        );
    }
}

export default Filter;
